var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "responsive-actions",
      class: { fixed: _vm.fixed, shadows: _vm.shadows },
    },
    [
      _c("c-button", {
        staticClass: "responsive-actions__reset",
        class: { "sm-border-color": !_vm.shadows },
        attrs: { size: "large", label: _vm.resetLabel },
        on: {
          click: function ($event) {
            return _vm.$emit("on-reset")
          },
        },
      }),
      _c("c-button", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.hideResetButton,
            expression: "!hideResetButton",
          },
        ],
        staticClass: "responsive-actions__save",
        attrs: {
          label: _vm.submitLabel,
          color: "primary",
          size: "large",
          "disabled-but-clickable": _vm.disabledButClickableSubmit,
          disabled: _vm.disableSubmit,
        },
        on: {
          click: function ($event) {
            return _vm.$emit("on-submit")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }